import React from "react";

const CustomProgressBar = (props) => {
  const { bgColor, completed ,baseBgColor,customLabel,labelLineHeight,labelPadding, labelSize,labelClassName,labelAlignment,borderRadius,labelColor,width,height,outerDivClassName } = props;
  const containerStyles = {
    height: `${height}`,
    width: `${width}`,
    backgroundColor: `${baseBgColor}`,
    borderRadius: `${borderRadius}`,
    margin: "5px 0 5px 0",
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor:`${bgColor}`,
    transition: 'width 1s ease-in-out',
    borderRadius: 'inherit',
    textAlign: 'right',
  }

  const labelStyles = {
    padding: 5,
    fontSize : `${labelSize}`,
    color: `${labelColor}`,
    fontWeight: 'bold',
    margin:"5px"
   
  }
  const labelStyleright = {
    fontSize: "100%",
    fontWeight: "600",
    color: "#222",
    position: "absolute",
    right: "-44px",
    width: "44px",
    textAlign: "left"
  }
  const labelStylesOutside = {
    fontSize : `${labelSize}`,
    color: `${labelColor}`,
    fontWeight: 500,
    padding : `${labelPadding}`
   // lineHeight : `${labelLineHeight}`
  }
  return (
    <div className={ labelAlignment === 'outside' ? 'out-side-flex' : 'file_upload_progress'}>
    <div style={containerStyles} tabIndex="0" aria-label={`${completed}%`} role="progressbar" className="progressReport">
      <div style={fillerStyles}>
        {labelAlignment !== 'outside' &&  labelAlignment !== 'right' ? <span className = {labelClassName} style={labelStyles}>{customLabel === '' ? completed :  customLabel}</span> : ''}
        {labelAlignment === 'right' ? <span className = {labelClassName} style={labelStyleright}>{customLabel === '' ? completed :  customLabel}</span> : ''}
      </div>
    </div>
    {labelAlignment === 'outside' ? <span className = {labelClassName} style={labelStylesOutside}>{`${completed}%`}</span> : ''}
    </div>
  );
};

export default CustomProgressBar;